import { ElMessageBox } from "element-plus"; // Import Element UI message box
import axios from "axios";

export default {
  data() {
    return {
      addUserForm: {
        emailId: '',
        firstName: '',
        lastName: '',
        mobilrNum:'',
        customerId: '',
      },
      registerRules: {
        firstName: [{ required: true, message: 'First name is required', trigger: 'blur' }],
        lastName: [{ required: true, message: 'Last name is required', trigger: 'blur' }],
        customerId: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          {
            type: 'email',
            message: 'Please enter a valid email address',
            trigger: ['blur', 'change'],
          },
        ],
        mobileNumber: [
          { required: true, message: 'mobile number is required', trigger: 'blur' },
          {
            pattern:  /^\+?\d{1,4}[-\s]?\d{10,15}$/,
            message:
              'Please enter a valid mobile number',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    async saveAddUserForm(userId) {
      this.$refs.addUserFormRules.validate((valid) => {
            if (valid) {
              this.$router.push({ name: 'user-details' });
              console.log('Form submitted:', this.form);
            } else {
              console.error('Validation failed');
            }
          });
      ElMessageBox.confirm(
        "Are you sure you want to save this user?",
        {
          confirmButtonText: "Save",
          cancelButtonText: "Cancel",
          type: "success",
        }
      ).then(async () => {
        try {
          // Simulate deleting the user with a dummy API call
          await axios.post(`https://jsonplaceholder.typicode.com/users/${userId}`);
          this.users = this.users.filter((user) => user.id !== userId);
        } catch (error) {
          this.error = error.message;
        }
      }).catch(() => {
        // User canceled the delete action
      });
    },
    // saveEditForm() {
    //
    // },
    cancelEditForm(){
      this.$router.push({ name: 'user-details' });

    }
  },
};